export default __webpack_public_path__ + "static/media/tuah.8d2dfef1.svg";